import { canWriteSchoolScopedDataCache } from './schoolDataCacheVersion';

const CACHE_VERSION = 'v1';

export function weeklyLearningGuideTrackColorsCacheKey(
  workspaceId: string,
  academicYear: number,
  gradeId: string
): string {
  return `cp.weeklyLearningGuideTrackColors.${CACHE_VERSION}.${workspaceId}.${academicYear}.${gradeId}`;
}

function parseColorMap(raw: unknown): Record<string, string> {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const out: Record<string, string> = {};
  Object.entries(raw as Record<string, unknown>).forEach(([k, v]) => {
    if (typeof k !== 'string' || typeof v !== 'string') return;
    const key = k.trim();
    const val = v.trim();
    if (key && val) out[key] = val;
  });
  return out;
}

export function loadWeeklyLearningGuideTrackColorsCache(
  workspaceId: string,
  academicYear: number,
  gradeId: string
): { found: boolean; map: Record<string, string> } {
  if (!workspaceId || !gradeId || typeof window === 'undefined') {
    return { found: false, map: {} };
  }
  try {
    const raw = window.localStorage.getItem(weeklyLearningGuideTrackColorsCacheKey(workspaceId, academicYear, gradeId));
    if (!raw) return { found: false, map: {} };
    return { found: true, map: parseColorMap(JSON.parse(raw)) };
  } catch {
    return { found: false, map: {} };
  }
}

export function saveWeeklyLearningGuideTrackColorsCache(
  workspaceId: string,
  academicYear: number,
  gradeId: string,
  map: Record<string, string>,
  force = false
): void {
  if (typeof window === 'undefined') return;
  if (!force && !canWriteSchoolScopedDataCache(workspaceId)) return;
  try {
    window.localStorage.setItem(
      weeklyLearningGuideTrackColorsCacheKey(workspaceId, academicYear, gradeId),
      JSON.stringify(map)
    );
  } catch {
    /* ignore */
  }
}
